import { render, staticRenderFns } from "./CreationCard.vue?vue&type=template&id=047ed680&scoped=true&"
import script from "./CreationCard.vue?vue&type=script&lang=ts&"
export * from "./CreationCard.vue?vue&type=script&lang=ts&"
import style0 from "./CreationCard.vue?vue&type=style&index=0&id=047ed680&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047ed680",
  null
  
)

export default component.exports